
import { Profile } from "@/hooks/useProfile";

interface Farm {
  id: number;
  name: string;
  username: string;
  avatar: string;
  cover: string;
  location: {
    lat: number;
    lng: number;
    address: string;
  };
  crops: string[];
  distance: string;
  description: string;
  verified: boolean;
  category: string;
  calculatedDistance: number;  // Added this property
  plantHardinessZone: string;
  userId?: string;
}

export const transformProfilesToFarms = (profiles: Profile[]): Farm[] => {
  return profiles.map((profile, index) => {
    // Extract crops from farm_goals or use default
    const crops = profile.farm_goals || ['Mixed Farming'];
    
    // Determine category based on farm goals or default
    const category = crops.includes('Organic Farming') ? 'Organic Farmers' :
                    crops.includes('Water Management') ? 'Sustainable Farmers' :
                    crops.includes('Pest Control') ? 'Crop Protection' :
                    'General Farming';

    // Calculate a stable distance for sorting (based on profile ID to maintain consistency)
    const calculatedDistance = ((parseInt(profile.id) || index + 1) * 7) % 50; // Stable pseudo-random distance

    return {
      id: index + 1,
      name: profile.farm_name || profile.username || 'Farm Profile',
      username: profile.username || 'farmer',
      avatar: profile.avatar_url || '/placeholder-avatar.png',
      cover: profile.farm_logo_url || '/placeholder-farm.jpg',
      location: {
        lat: profile.latitude || 33.5379,
        lng: profile.longitude || -82.1265,
        address: profile.location || 'Evans, GA'
      },
      crops: crops,
      distance: `${calculatedDistance.toFixed(1)} miles`,
      calculatedDistance: calculatedDistance,  // Added this for sorting
      description: profile.bio || '2nd generation farmer. Certified organic crops',
      verified: true,
      category: category,
      plantHardinessZone: profile.usda_zone || 'Zone 8a',
      userId: profile.user_id
    };
  });
};
